<div class="agpr-entityProfile">
    <div
        class="agpr-entityProfile-container"
        [ngClass]="{'agpr-entityProfile--fullPage': !dialogMode}"
    >
        <div class="agpr-entityProfile-column agpr-entityProfile-column--right">
            <div class="agpr-entityProfile-toolbar">
                <div class="agpr-entityProfile-toolbar-content">
                    <agpr-entity-business-card-expanded
                        #businessCard [id]="id + '_fullProfileBusinessCard'"
                        class="agpr-entityProfile-businessCard"
                        [entity]="fullEntity" [canOpenFullProfile]="false"
                        [contactPrivateData]="contactPrivateData" [outletPrivateData]="outletPrivateData"
                        [currentUser]="currentUser"
                        (selectedEmploymentChanged)="targetingRhpContextsService.changeSelectedEmployment($event.id)"
                        (showContactEditor)="showContactEditor.emit()">
                    </agpr-entity-business-card-expanded>
                </div>
            </div>
            @if (handleTypes?.length > 0) {
                <div class="agpr-profileSection agpr-handles agpr-profileSection--Margin">
                    @for (handleType of handleTypes; track handleType) {
                        <ng-container>
                            <div class="agpr-handles-type">
                                <span
                                    role="img"
                                    [class]="handleTypeIcons[handleType.type]"
                                    [agprTooltip]="handleType.tooltip"
                                    tooltipPosition="top"
                                ></span>
                            </div>
                            <div class="agpr-handles-container">
                                @for (handle of handleType.handles; track handle) {
                                    <div class="agpr-handles-handle">
                                        @if (handle.link) {
                                        <a #link (mouseenter)="checkTruncatedText(link)" [pTooltip]="isTruncated? handle.value: null" [href]="handle.link" target="_blank" rel="noopener"
                                            class="agpr-handles-link">
                                            {{ handle.value.trim() }}
                                        </a>
                                        }
                                        @if (!handle.link) {
                                        <ng-container>
                                            <span #noLink (mouseenter)="checkTruncatedText(noLink)" class="agpr-handles-noLink" tooltipPosition="right"
                                                [agprTooltip]="isTruncated? handle.value: null">
                                                {{ handle.value }}
                                            </span>
                                        </ng-container>
                                        }
                                        @if (handle.isPrivateData) {
                                        <span role="img"
                                            class="agpr-handles-privateBadge fa-duotone fa-regular fa-shield-keyhole"
                                            agprTooltip="Discover.addPrivateDataDialog.privateData"></span>
                                        }
                                        @if (handle.primary && handleType.handles.length > 1) {
                                        <span role="img"
                                            class="agpr-handles-privateBadge fa-regular fa-duotone fa-award"
                                            agprTooltip="Discover.entityProfile.handle.primary"></span>
                                        }
                                        @if (handle.preferred) {
                                        <span role="img" class="agpr-handles-privateBadge fa-solid fa-star"
                                            agprTooltip="Discover.entityProfile.handle.preferred"></span>
                                        }
                                        @if (!fullEntity?.privateContactMetadata &&
                                            !handle.preferred &&
                                            handle.handleType === handleTypeEnum.EMAIL &&
                                            ((handle.primary && hasPreferredEmail) || !handle.primary)
                                        ) {
                                            <span class="agpr-handles-contextMenu">
                                                <!-- You are only able to set the primary as "preferred" as a way of clearing a
                                                            previous preference. Private contacts cannot have a preferred email since
                                                            users are allowed to modify the primary email instead (in the editor)-->
                                                <agpr-button
                                                    [style]="buttonTypes.icon"
                                                    [tooltip]="'Discover.entityProfile.handle.preferred.set'"
                                                    (click)="setPreferred(handle)"
                                                    class="agpr-handles-contextMenu-setPreferred"
                                                    icon="fa-regular fa-star"
                                                ></agpr-button>
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                        </ng-container>
                    }
                    @if (privateAddresses?.length > 0 || fullEntity.addressLine1 || fullEntity.addressLine2 || fullEntity.geography || fullEntity.postalCode) {
                        <div class="agpr-handles-type">
                            <span
                                role="img"
                                class="fa-solid fa-location-dot"
                                [agprTooltip]="'Discover.entityProfile.address'"
                                tooltipPosition="top"
                            ></span>
                        </div>
                        <div class="agpr-handles-container">
                            @if (fullEntity.addressLine1 || fullEntity.addressLine2 || fullEntity.geography || fullEntity.postalCode) {
                                <div class="agpr-handles-handle">
                                    <div class="agpr-addresses">
                                        <div>{{ fullEntity.addressLine1 }}</div>
                                        <div>{{ fullEntity.addressLine2 }}</div>
                                        <div>{{ fullEntity.geography?.keyString }}</div>
                                        <div>{{ fullEntity.postalCode }}</div>
                                    </div>
                                </div>
                            }
                            @if (privateAddresses?.length > 0) {
                                @for (address of privateAddresses; track address) {
                                    <div class="agpr-handles-handle">
                                        <div class="agpr-addresses">
                                            @if (address.addressLine1) {
                                                <div class="agpr-addresses-field">
                                                    {{ address.addressLine1 }}
                                                </div>
                                            }
                                            @if (address.addressLine2) {
                                                <div class="agpr-addresses-field">
                                                    {{ address.addressLine2 }}
                                                </div>
                                            }
                                            @if (address.geography?.keyString) {
                                                <div class="agpr-addresses-field">
                                                    {{ address.geography.keyString }}
                                                </div>
                                            }
                                            @if (address.postalCode) {
                                                <div class="agpr-addresses-field">
                                                    {{ address.postalCode }}
                                                </div>
                                            }
                                            <span
                                                role="img"
                                                class="agpr-addresses-privateBadge fa-regular fa-duotone fa-shield-keyhole"
                                                agprTooltip="Discover.addPrivateDataDialog.privateData"
                                            ></span>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            }
            @if (entityType === entityTypes.CONTACT && (hasSystemAddresses || outletPrivateAddresses.length > 0  && showSection)){
                <div class="agpr-profileSection agpr-profileSection--Margin">
                    <agpr-panel header="Discover.entityProfile.outletAddress" [toggleable]='false' [marginTop]="0"
                        [paddingBottom]="0">
                        @if (hasSystemAddresses) {
                        <div class="agpr-addresses">
                            <div>{{ outletEntity.addressLine1 }}</div>
                            <div>{{ outletEntity.addressLine2 }}</div>
                            <div>{{ outletEntity.geography?.keyString }}</div>
                            <div>{{ outletEntity.postalCode }}</div>
                        </div>
                        }
                        @for (address of outletPrivateAddresses; track address) {
                            <div class="agpr-addresses">
                                @if (address.addressLine1) {
                                    <div class="agpr-addresses-field">
                                        {{ address.addressLine1 }}
                                    </div>
                                }
                                @if (address.addressLine2) {
                                    <div class="agpr-addresses-field">
                                        {{ address.addressLine2 }}
                                    </div>
                                }
                                @if (address.geography?.keyString) {
                                    <div class="agpr-addresses-field">
                                        {{ address.geography.keyString }}
                                    </div>
                                }
                                @if (address.postalCode) {
                                    <div class="agpr-addresses-field">
                                        {{ address.postalCode }}
                                    </div>
                                }
                                <span
                                    role="img"
                                    class="agpr-addresses-privateBadge fa-regular fa-duotone fa-shield-keyhole"
                                    agprTooltip="Discover.addPrivateDataDialog.privateData"
                                ></span>
                            </div>
                        }
                    </agpr-panel>

                    <!-- TODO : map thing -->
                </div>
            }
            <div class="agpr-entityProfile-column">
                @if (fullEntity?.entityType == entityTypes.CONTACT && _selectedEmployment?.outlet?.targetAudiences?.length > 0) {
                    <div class="agpr-profileSection agpr-profileSection--Margin">
                        <agpr-panel
                            header="Discover.entityProfile.targetAudiences"
                            [toggleable]='false'
                            [marginTop]="0"
                            [paddingBottom]="0"
                        >
                            <div class="agpr-profileSection-content agpr-profileSection-content-last">
                                @for (targetAudience of outletEntity.targetAudiences; track targetAudience; let last = $last) {
                                    <div>
                                        {{ targetAudience.displayString }}
                                    </div>
                                }
                            </div>
                        </agpr-panel>
                    </div>
                }
            </div>
        </div>
        <div class="agpr-entityProfile-column agpr-entityProfile-column--left">
        <div class="agpr-entityProfile-wrapper">
            @if (fullEntity?.bio) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.bio"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        <div class="agpr-profileSection-content bio">{{ fullEntity.bio }}</div>
                    </agpr-panel>
                </div>
            }
            @if (roleFamilies?.length > 0) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.jobRoles"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        @for (roleFamily of roleFamilies;track roleFamily; let last = $last) {
                            <div
                                class="agpr-profileSection-content"
                                [ngClass]="{'agpr-profileSection-content-last' : last}"
                            >
                                <span class="agpr-profileSection-attribute">
                                    {{ roleFamily.family | titlecase }}
                                </span>
                                <div class="agpr-profileSection-attributeValue">
                                    @for (role of roleFamily.roles;track role; let last = $last) {
                                        <span>
                                            {{ role.displayString }}{{ !last ? ', ' : ''}}
                                        </span>
                                    }
                                </div>
                            </div>
                        }
                    </agpr-panel>
                </div>
            }
            @if (subjects?.length > 0) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.subjects"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        @for (topSubject of subjects; track topSubject ;let last = $last) {
                            <div
                                class="agpr-profileSection-content"
                                [ngClass]="{'agpr-profileSection-content-last' : last}"
                            >
                                <span class="agpr-profileSection-attribute">
                                    {{ topSubject.name }}
                                </span>
                                <div
                                    class="agpr-profileSection-attributeValue"
                                    [ngClass]="{'agpr-profileSection-attributeValue-subjects' : !last}"
                                >
                                    @for (childSubject of topSubject.children; track childSubject; let last = $last) {
                                        <span>
                                            {{ childSubject.name }}{{ !last ? ', ' : ''}}
                                        </span>
                                    }
                                </div>
                            </div>
                        }
                    </agpr-panel>
                </div>
            }
        </div>
        <div class="agpr-entityProfile-wrapper">
            @if (outletEntity?.circulations && outletEntity?.circulations.length > 0) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.audienceReach"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        @for (circulation of outletEntity.circulations; track circulation; let last = $last) {
                            <div
                                class="agpr-profileSection-content"
                                [ngClass]="{'agpr-profileSection-content-last' : last}"
                            >
                                <span class="agpr-profileSection-attribute">
                                    {{ circulation.circulationType.displayString }}
                                </span>
                                <span
                                    [class]="(circulation.isSimilarWeb ? 'agpr-profileSection-circulation-uniqueVisitors agpr-profileSection-circulation': 'agpr-profileSection-circulation')"
                                >
                                    {{ circulation.value | number }}
                                    @if (circulation.isSimilarWeb) {
                                        <a
                                            target="_blank"
                                            href="http://www.similarweb.com/"
                                            [agprTooltip]="similarWebTooltip"
                                            tooltipStyleClass="agpr-similarWeb-tooltip"
                                            [useTooltipAsAriaLabel]="false"
                                            [attr.aria-label]="'Common.audienceReach.similarWeb' | localize"
                                            [escape]="false"
                                        >
                                            <img
                                                class="agpr-attributeList-audienceReach-similarWeb"
                                                [src]="appBaseHref + 'assets/images/SimilarWeb-logo.svg'"
                                                [alt]="'Common.audienceReach.similarWeb' | localize"
                                                width="18"
                                                height="18"
                                            />
                                        </a>
                                    }
                                </span>
                            </div>
                        }
                    </agpr-panel>
                </div>
            }
            @if (outletEntity?.domainAuthority) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.domainAuthority"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        <div class="agpr-profileSection-content agpr-profileSection-content-last">
                            <div class="agpr-profileSection-circulation agpr-profileSection-circulation-domainAuthority">
                                <span>
                                    {{outletEntity.domainAuthority | number}}
                                </span>
                                <a class="agpr-profileSection-circulation-link" target="_blank" href="https://moz.com">
                                    <img class="agpr-profileSection-mozLogo" [src]="appBaseHref + 'assets/images/moz-logo.svg'"
                                        [alt]="'Common.domainAuthority.moz' | localize" />
                                </a>
                                <span role="img" class="fa-regular fa-circle-info agpr-profileSection-mozTooltip"
                                    agprTooltip="Discover.entityProfile.domainAuthorityTooltip"></span>
                            </div>
                        </div>
                    </agpr-panel>
                </div>
            }
            @if (fullEntity?.entityType == entityTypes.CONTACT && _selectedEmployment?.outlet?.mediaMarkets?.length > 0) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.mediaMarkets"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        @for(market of (_selectedEmployment.outlet.mediaMarkets | mediaMarketDisplay); track market; let last = $last) {
                            <div
                                class="agpr-profileSection-content"
                                [ngClass]="{'agpr-profileSection-content-last' : last}"
                            >
                                <span class="agpr-profileSection-attribute">
                                    {{ market.header }}
                                </span>
                                <div class="agpr-profileSection-attributeValue">
                                    @for (contentItem of market.content; track contentItem) {
                                        <span>
                                            {{ contentItem }}
                                        </span>
                                    }
                                </div>
                            </div>
                        }
                    </agpr-panel>
                </div>
            }
            @if (fullEntity?.entityType == entityTypes.CONTACT && languages?.length) {
                <div class="agpr-profileSection">
                    <agpr-panel
                        header="Discover.entityProfile.language"
                        [toggleable]='false'
                        [marginTop]="0"
                        [paddingBottom]="0"
                    >
                        <div class="agpr-profileSection-content agpr-profileSection-content-last">
                            @for (language of languages; track language; let isLast = $last) {
                                <span>
                                    {{ language.name | localize }}{{ isLast? '' : ',' }}
                                </span>
                            }
                        </div>
                    </agpr-panel>
                </div>
            }
            @if (roleFamilies?.length > 0) {
                @if (fullEntity?.entityType == entityTypes.OUTLET) {
                    <div class="agpr-profileSection">
                        <agpr-entity-profile-section [profileSection]="outletProductSection"></agpr-entity-profile-section>
                    </div>
                }
                @if (isGeoRestricted) {
                    <div class="agpr-profileSection">
                        <ng-container>
                            <div class="agpr-profileSection">
                                <agpr-panel header="Discover.entityProfile.contactInformation" [toggleable]='false' [marginTop]="0"
                                    [paddingBottom]="0">
                                    <div class="agpr-entityProfile-upsellCard agpr-showMoreOverlay-upsellCard">
                                        <span class="agpr-entityProfile-upsellCard-lockIcon fa-regular fa-duotone fa-lock"></span>
                                        <div class="agpr-entityProfile-upsellCard-info">
                                            <span>
                                                {{'Discover.entityProfile.targetingUpsell.contactMessage.geoRestriction' | localize}}
                                            </span>
                                        </div>
                                        <agpr-button id="entityProfile_contactButton_collapsed"
                                            label="Discover.entityProfile.targetingUpsell.contactButton" [style]="buttonTypes.primary"
                                            (click)="navigateToContactUs()"></agpr-button>
                                    </div>
                                </agpr-panel>
                            </div>
                        </ng-container>
                    </div>
                }
            }
            @if (fullEntity?.entityType == entityTypes.OUTLET) {
                <ng-container>
                    <agpr-entity-profile-section [profileSection]="coverageProfileSection"></agpr-entity-profile-section>
                </ng-container>
            }
        </div>
    </div>
    </div>
    <div class="agpr-entityProfile-actions">
        <agpr-split-button
            class="agpr-entityProfile-buttonContainer"
            [id]="id + '_contactBusinessCard_actions'"
            [label]="'Discover.targeting.actions.actions' | localize"
            [style]="buttonTypes.tertiary"
            panelPositionY="top"
            panelPositionX="right"
            [caretDown]="false"
            [options]="actions"
        ></agpr-split-button>
    </div>
</div>
